import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './styles/css/App.css';
import store from './app/store';
import Main from './components/Main'
import TC from './components/TC';

function App() {
  return (
    <div className="page container-sm">
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Main />} />
            <Route path='/privacy-policy' element={<TC />} />
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
